// extracted by mini-css-extract-plugin
export default {"main":"cleantype_main__hPwdk","link":"cleantype_link__8lH4g","containerflat":"cleantype_containerflat__D++xJ"};